import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "row form-field q-col-gutter-x-md" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "text-negative" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "row form-field q-col-gutter-x-md" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "text-negative" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "row items-start full-width" }
const _hoisted_10 = { class: "col q-pr-md" }
const _hoisted_11 = { class: "ellipsis" }
const _hoisted_12 = { class: "flex justify-between items-baseline all-pointer-events" }
const _hoisted_13 = { class: "text-negative" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "col row no-wrap" }
const _hoisted_16 = {
  key: 0,
  class: "q-mt-lg q-pl-md col-auto"
}
const _hoisted_17 = {
  key: 0,
  class: "row form-field q-col-gutter-x-md"
}
const _hoisted_18 = {
  key: 2,
  class: "form-field"
}
const _hoisted_19 = { class: "row items-start" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "flex items-end" }
const _hoisted_22 = {
  key: 0,
  class: "form-field"
}
const _hoisted_23 = { class: "row items-start" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "flex items-end" }
const _hoisted_26 = {
  key: 0,
  class: "col-auto q-mt-lg q-pl-md"
}
const _hoisted_27 = { class: "row items-start" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = {
  key: 0,
  class: "col-auto q-mt-lg q-pl-md"
}
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = {
  key: 5,
  class: "row form-field q-col-gutter-x-md"
}
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = {
  key: 6,
  class: "row form-field q-col-gutter-x-md"
}
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "form-field" }
const _hoisted_38 = { class: "row items-start" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "col-auto q-mt-lg q-pl-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.contact ? _ctx.t('TITLE.UPDATE', { object: _ctx.t('CONTACT.LOW.SING') }) : _ctx.t('TITLE.CREATE', { object: _ctx.t('CONTACT.LOW.SING') }),
    onConfirm: _ctx.onSubmit,
    "confirm-label": _ctx.contact ? _ctx.t('ACTION.CONFIRM') : _ctx.t('ACTION.CREATE'),
    onCancel: _ctx.closeForm,
    "disable-confirm": _ctx.canSubmit.length > 0,
    loading: _ctx.loading,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-pa-sm" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            onReset: _ctx.onReset,
            id: "contact-form",
            ref: "contactForm"
          }, {
            default: _withCtx(() => [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_q_input, _mergeProps({
                            placeholder: _ctx.t('CONTACT_FIRSTNAME_PLACEHOLDER'),
                            autofocus: !_ctx.name?.length,
                            rules: [(val) => val?.trim().length > 0 && val?.trim().length <= _ctx.MAX_LENGTH.CONTACT.FIRST_NAME]
                          }, _ctx.INPUT_LG, {
                            readonly: _ctx.isUser,
                            "label-slot": "",
                            modelValue: _ctx.firstName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                            modelModifiers: { trim: true }
                          }), {
                            label: _withCtx(() => [
                              _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_HEADER_BODY)), [
                                _createTextVNode(_toDisplayString(_ctx.t('CONTACT_FIRSTNAME')) + " ", 1),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('MANDATORY')), 1)
                              ], 16)
                            ]),
                            error: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.WARNING_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t(`CONTACT_FIRSTNAME_${_ctx.firstName?.trim().length ? 'LONG' : 'EMPTY'}`, { x: _ctx.MAX_LENGTH.CONTACT.FIRST_NAME })), 1)
                            ]),
                            _: 1
                          }, 16, ["placeholder", "autofocus", "rules", "readonly", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_q_input, _mergeProps({
                            placeholder: _ctx.t('CONTACT_PREFERRED_NAME_PLACEHOLDER'),
                            autofocus: _ctx.name && _ctx.name.length && !_ctx.name.includes(' '),
                            rules: [(val) => (val?.trim()?.length ?? 0) <= _ctx.MAX_LENGTH.CONTACT.PREFERRED_NAME]
                          }, _ctx.INPUT_LG, {
                            label: _ctx.t('CONTACT_PREFERRED_NAME'),
                            modelValue: _ctx.preferredName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.preferredName) = $event)),
                            modelModifiers: { trim: true }
                          }), {
                            error: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.WARNING_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('CONTACT_PREFERRED_NAME_LONG', { x: _ctx.MAX_LENGTH.CONTACT.PREFERRED_NAME })), 1)
                            ]),
                            _: 1
                          }, 16, ["placeholder", "autofocus", "rules", "label", "modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_q_input, _mergeProps({
                            placeholder: _ctx.t('CONTACT_LASTNAME_PLACEHOLDER'),
                            autofocus: _ctx.name && _ctx.name.length && !_ctx.name.includes(' '),
                            rules: [(val) => val?.trim().length > 0 && val?.trim().length <= _ctx.MAX_LENGTH.CONTACT.LAST_NAME]
                          }, _ctx.INPUT_LG, {
                            readonly: _ctx.isUser,
                            "label-slot": "",
                            modelValue: _ctx.lastName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastName) = $event)),
                            modelModifiers: { trim: true }
                          }), {
                            label: _withCtx(() => [
                              _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_HEADER_BODY)), [
                                _createTextVNode(_toDisplayString(_ctx.t('CONTACT_LASTNAME')) + " ", 1),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('MANDATORY')), 1)
                              ], 16)
                            ]),
                            error: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.WARNING_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t(`CONTACT_LASTNAME_${_ctx.lastName?.trim().length ? 'LONG' : 'EMPTY'}`, { x: _ctx.MAX_LENGTH.CONTACT.LAST_NAME })), 1)
                            ]),
                            _: 1
                          }, 16, ["placeholder", "autofocus", "rules", "readonly", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_iuf_select, _mergeProps({
                            options: _ctx.salutationOptions,
                            "placeholder-value": _ctx.t('SELECT_OPTION').toString(),
                            label: _ctx.t('CONTACT_SALUTATION'),
                            onRemove: _ctx.removeSalutation,
                            "option-label": "label",
                            removable: ""
                          }, _ctx.SELECT_SINGLE_LG, {
                            modelValue: _ctx.salutation,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.salutation) = $event))
                          }), null, 16, ["options", "placeholder-value", "label", "onRemove", "modelValue"])
                        ])
                      ]),
                      _createVNode(_component_q_separator, {
                        class: "q-my-lg",
                        color: "grey-light"
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyLinks, (companyLink, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "form-field"
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_iuf_select, _mergeProps({
                                class: { 'company-link': index === 0 },
                                "selected-item-slot": "",
                                disable: _ctx.isInternalContact,
                                "allow-create": !_ctx.companyExactMatch,
                                autofocus: _ctx.name?.includes(' '),
                                mandatory: !index,
                                options: _ctx.companyOptions,
                                "placeholder-value": _ctx.t('SELECT_OPTION'),
                                "label-slot": "",
                                "option-label": "name",
                                "option-value": "dobjId",
                                "onUpdate:modelValue": (element) => _ctx.addCompany(companyLink, element),
                                onCreateValue: (label) => _ctx.createCompany(companyLink, label),
                                onFilter: _ctx.searchCompanies
                              }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                                modelValue: companyLink.company,
                                "onUpdate:modelValue": ($event: any) => ((companyLink.company) = $event)
                              }), {
                                option: _withCtx((scope) => [
                                  _createVNode(_component_q_item_section, { side: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: _ctx.isDirectoryCompany(scope.opt) ? _ctx.ICONS_NAME.DATABASE_OUTLINE : _ctx.ICONS_NAME.COMPANY_OUTLINE
                                      }, null, 8, ["name"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, _mergeProps(_ctx.TEXT_CONTENT_BODY, { class: "ellipsis" }), {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.opt.name), 1)
                                        ]),
                                        _: 2
                                      }, 1040)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                "selected-item": _withCtx((scope) => [
                                  _createVNode(_component_q_item, { class: "row items-center justify-start no-wrap" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        class: "q-mr-sm",
                                        name: _ctx.isDirectoryCompany(scope.opt) ? _ctx.ICONS_NAME.DATABASE_OUTLINE : _ctx.ICONS_NAME.COMPANY_OUTLINE
                                      }, null, 8, ["name"]),
                                      _createElementVNode("span", _hoisted_11, _toDisplayString(scope.opt.name), 1),
                                      _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.opt.name), 1)
                                        ]),
                                        _: 2
                                      }, 1040)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                label: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", null, [
                                      _createTextVNode(_toDisplayString(_ctx.t('CONTACT_COMPANY')) + " ", 1),
                                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('MANDATORY')), 1)
                                    ]),
                                    (index === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                          _createVNode(_component_q_toggle, {
                                            disable: (!!_ctx.contact && _ctx.internalContact) || (!!_ctx.contact && _ctx.isContributor),
                                            size: "md",
                                            "onUpdate:modelValue": [
                                              _ctx.toggleInternalContact,
                                              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isInternalContact) = $event))
                                            ],
                                            modelValue: _ctx.isInternalContact,
                                            label: _ctx.t('MY_COMPANY')
                                          }, null, 8, ["disable", "onUpdate:modelValue", "modelValue", "label"]),
                                          (!!_ctx.contact && _ctx.isContributor)
                                            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.t('SWITCH_TOOLTIP_CONTRIBUTOR')), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1040, ["class", "disable", "allow-create", "autofocus", "mandatory", "options", "placeholder-value", "onUpdate:modelValue", "onCreateValue", "onFilter", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_q_input, _mergeProps({
                                class: "col",
                                placeholder: _ctx.t('CONTACT_JOB_PLACEHOLDER'),
                                label: _ctx.t('CONTACT_JOB'),
                                rules: [(val) => (val?.trim().length ?? 0) <= _ctx.MAX_LENGTH.CONTACT.JOB],
                                "hide-bottom-space": ""
                              }, _ctx.INPUT_LG, {
                                modelValue: companyLink.jobTitle,
                                "onUpdate:modelValue": ($event: any) => ((companyLink.jobTitle) = $event)
                              }), {
                                error: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: _ctx.ICONS_NAME.WARNING_SOLID
                                  }, null, 8, ["name"]),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t(`CONTACT_JOB_${companyLink.jobTitle?.trim().length ? 'LONG' : 'EMPTY'}`, { x: _ctx.MAX_LENGTH.CONTACT.JOB })), 1)
                                ]),
                                _: 2
                              }, 1040, ["placeholder", "label", "rules", "modelValue", "onUpdate:modelValue"]),
                              (index > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_q_btn, _mergeProps({
                                      onClick: ($event: any) => (_ctx.removeLink(index))
                                    }, _ctx.BTN_NEGATIVE_SECONDARY_LG), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          name: _ctx.ICONS_NAME.DELETE_OUTLINE
                                        }, null, 8, ["name"])
                                      ]),
                                      _: 2
                                    }, 1040, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.isInternalContact)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_iuf_select, _mergeProps({ class: "col-6" }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                              modelValue: _ctx.businessUnit,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.businessUnit) = $event)),
                              label: _ctx.t('BUSINESS_UNIT'),
                              options: _ctx.businessUnitOptions,
                              "placeholder-value": _ctx.t('SELECT_OPTION'),
                              "option-label": "label",
                              "option-value": "dobjId",
                              "selected-item-slot": "",
                              onFilter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchBusinessUnit({ ...$event }, undefined, _ctx.InternalContactListValues.BUSINESS_UNIT)))
                            }), {
                              "selected-item": _withCtx((scope) => [
                                (_openBlock(), _createBlock(_component_iap_chip, {
                                  tooltip: "",
                                  label: scope.opt.label,
                                  key: scope.opt.dobjId,
                                  removable: "",
                                  onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                                }, null, 8, ["label", "onRemove"]))
                              ]),
                              _: 1
                            }, 16, ["modelValue", "label", "options", "placeholder-value"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.companyLinks?.length < 5 && !_ctx.isInternalContact)
                        ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                            key: 1,
                            onClick: _ctx.addLink,
                            class: "form-field"
                          }, _ctx.BTN_SECONDARY_LG), {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.PLUS_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('CONTACT_LINK_ADD')), 1)
                            ]),
                            _: 1
                          }, 16, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_separator, {
                        class: "q-my-lg",
                        color: "grey-light"
                      }),
                      (_ctx.isUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_q_input, _mergeProps({
                                  label: _ctx.t('CONTACT_EMAIL')
                                }, _ctx.INPUT_LG, {
                                  "bottom-slot": "",
                                  readonly: "",
                                  modelValue: _ctx.userEmail,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userEmail) = $event))
                                }), {
                                  hint: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_21, [
                                      _createVNode(_component_q_icon, {
                                        name: _ctx.ICONS_NAME.INFO_CIRCLE_SOLID,
                                        color: "info",
                                        class: "q-mr-xs"
                                      }, null, 8, ["name"]),
                                      _createTextVNode(" " + _toDisplayString(_ctx.t('EMAIL_INTERNAL_HINT')), 1)
                                    ])
                                  ]),
                                  _: 1
                                }, 16, ["label", "modelValue"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (email, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (email !== _ctx.userEmail)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_q_input, _mergeProps({
                                      placeholder: _ctx.t('CONTACT_EMAIL_PLACEHOLDER'),
                                      label: _ctx.t('CONTACT_EMAIL'),
                                      rules: [(val) => _ctx.isEmailValid(val)]
                                    }, _ctx.INPUT_LG, {
                                      "bottom-slot": "",
                                      "lazy-rules": "",
                                      modelValue: _ctx.emails[index],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.emails[index]) = $event)
                                    }), _createSlots({
                                      error: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          color: "negative",
                                          name: _ctx.ICONS_NAME.WARNING_SOLID
                                        }, null, 8, ["name"]),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t('EMAIL_NOT_VALID', { email })), 1),
                                        _createVNode(_component_q_tooltip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.t('EMAIL_NOT_VALID', { email })), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, [
                                      (_ctx.isInternalContact)
                                        ? {
                                            name: "hint",
                                            fn: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_25, [
                                                _createVNode(_component_q_icon, {
                                                  name: _ctx.ICONS_NAME.INFO_CIRCLE_SOLID,
                                                  color: "info",
                                                  class: "q-mr-xs"
                                                }, null, 8, ["name"]),
                                                _createTextVNode(" " + _toDisplayString(_ctx.t('EMAIL_INTERNAL_HINT')), 1)
                                              ])
                                            ]),
                                            key: "0"
                                          }
                                        : undefined
                                    ]), 1040, ["placeholder", "label", "rules", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  (index > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _createVNode(_component_q_btn, _mergeProps({
                                          onClick: ($event: any) => (_ctx.removeEmail(index))
                                        }, _ctx.BTN_NEGATIVE_SECONDARY_LG), {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_icon, {
                                              name: _ctx.ICONS_NAME.DELETE_OUTLINE
                                            }, null, 8, ["name"])
                                          ]),
                                          _: 2
                                        }, 1040, ["onClick"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      (_ctx.emails?.length < 5)
                        ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                            key: 3,
                            onClick: _ctx.addEmail,
                            class: "q-my-md"
                          }, _ctx.BTN_SECONDARY_LG), {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.PLUS_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('CONTACT_EMAIL_ADD')), 1)
                            ]),
                            _: 1
                          }, 16, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phones, (phone, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "form-field"
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_q_input, _mergeProps({
                                placeholder: _ctx.t('CONTACT_PHONE_PLACEHOLDER'),
                                label: _ctx.t('CONTACT_PHONES')
                              }, _ctx.INPUT_LG, {
                                modelValue: _ctx.phones[index],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.phones[index]) = $event)
                              }), null, 16, ["placeholder", "label", "modelValue", "onUpdate:modelValue"])
                            ]),
                            (index > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createVNode(_component_q_btn, _mergeProps({
                                    onClick: ($event: any) => (_ctx.removePhone(index))
                                  }, _ctx.BTN_NEGATIVE_SECONDARY_LG), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: _ctx.ICONS_NAME.DELETE_OUTLINE
                                      }, null, 8, ["name"])
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.phones?.length < 5)
                        ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                            key: 4,
                            onClick: _ctx.addPhone
                          }, _ctx.BTN_SECONDARY_LG, { class: "q-my-md" }), {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.PLUS_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('CONTACT_PHONE_ADD')), 1)
                            ]),
                            _: 1
                          }, 16, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_separator, {
                        class: "q-my-lg",
                        color: "grey-light"
                      }),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_q_input, _mergeProps({
                          placeholder: _ctx.t('CONTACT_ADDRESS1_PLACEHOLDER')
                        }, _ctx.INPUT_LG, {
                          label: _ctx.t('CONTACT_ADDRESS1'),
                          modelValue: _ctx.address.address1,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.address1) = $event))
                        }), null, 16, ["placeholder", "label", "modelValue"])
                      ]),
                      (_ctx.address)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_q_input, _mergeProps({
                                label: _ctx.t('CONTACT_CITY'),
                                placeholder: _ctx.t('CONTACT_CITY_PLACEHOLDER')
                              }, _ctx.INPUT_LG, {
                                modelValue: _ctx.address.city,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.city) = $event))
                              }), null, 16, ["label", "placeholder", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_q_input, _mergeProps({
                                label: _ctx.t('CONTACT_ZIP'),
                                placeholder: _ctx.t('CONTACT_ZIP_PLACEHOLDER')
                              }, _ctx.INPUT_LG, {
                                modelValue: _ctx.address.zip,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.address.zip) = $event))
                              }), null, 16, ["label", "placeholder", "modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.address)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_q_input, _mergeProps({
                                label: _ctx.t('CONTACT_STATE'),
                                placeholder: _ctx.t('CONTACT_STATE_PLACEHOLDER')
                              }, _ctx.INPUT_LG, {
                                modelValue: _ctx.address.state,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.state) = $event))
                              }), null, 16, ["label", "placeholder", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_iuf_select, _mergeProps({
                                options: _ctx.countryOptions,
                                "placeholder-value": _ctx.t('CONTACT_COUNTRY_SEARCH_PLACEHOLDER'),
                                label: _ctx.t('CONTACT_COUNTRY'),
                                "option-label": "label",
                                "option-value": "dobjId",
                                onFilter: _ctx.searchCountry
                              }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                                modelValue: _ctx.address.country,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.address.country) = $event)),
                                removable: ""
                              }), null, 16, ["options", "placeholder-value", "label", "onFilter", "modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_q_input, _mergeProps({
                          placeholder: _ctx.t('CONTACT_LINKEDIN_URL_PLACEHOLDER'),
                          "bottom-slot": "",
                          "lazy-rules": ""
                        }, _ctx.INPUT_LG, {
                          label: _ctx.t('CONTACT_LINKEDIN_URL'),
                          rules: [(val) => _ctx.isUrlValid(val)],
                          modelValue: _ctx.linkedInUrl,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.linkedInUrl) = $event))
                        }), {
                          error: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              color: "negative",
                              name: _ctx.ICONS_NAME.WARNING_SOLID
                            }, null, 8, ["name"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('URL_NOT_VALID', { url: _ctx.linkedInUrl })), 1)
                          ]),
                          _: 1
                        }, 16, ["placeholder", "label", "rules", "modelValue"])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (url, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "form-field"
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_q_input, _mergeProps({
                                placeholder: _ctx.t('CONTACT_URL_PLACEHOLDER'),
                                label: _ctx.t('CONTACT_URL'),
                                "lazy-rules": ""
                              }, _ctx.INPUT_LG, {
                                rules: [(val) => _ctx.isUrlValid(val)],
                                modelValue: _ctx.urls[index],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.urls[index]) = $event)
                              }), {
                                error: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: _ctx.ICONS_NAME.WARNING_SOLID
                                  }, null, 8, ["name"]),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t('URL_NOT_VALID', { url })), 1)
                                ]),
                                _: 2
                              }, 1040, ["placeholder", "label", "rules", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_q_btn, _mergeProps({
                                onClick: ($event: any) => (_ctx.removeUrl(index))
                              }, _ctx.BTN_NEGATIVE_SECONDARY_LG), {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: _ctx.ICONS_NAME.DELETE_OUTLINE
                                  }, null, 8, ["name"])
                                ]),
                                _: 2
                              }, 1040, ["onClick"])
                            ])
                          ])
                        ]))
                      }), 128)),
                      (_ctx.urls?.length < 1)
                        ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                            key: 7,
                            onClick: _ctx.addUrl,
                            class: "form-field"
                          }, _ctx.BTN_SECONDARY_LG), {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: _ctx.ICONS_NAME.PLUS_SOLID
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('CONTACT_URL_ADD')), 1)
                            ]),
                            _: 1
                          }, 16, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onReset"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "onConfirm", "confirm-label", "onCancel", "disable-confirm", "loading"]))
}